import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function MpWidalEsrForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    typhiO: "",
    typhiH: "",
    paraAH: "",
    paraBH: "",

    mpAntigen: "",
    mpParasite: "",

    crpQual: "",
    crpQuant: "",

    raTest: "",
    raQuant: "",

    randomSugar: "",

    esr: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>MP WIDAL + ESR FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">SEROLOGY - WIDAL EXAMINATION</h5>
        <div className="mb-2">
          <label>S. Typhi (O) Antibody Titre:</label>
          <input
            type="text"
            className="form-control"
            name="typhiO"
            value={form.typhiO}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>S. Typhi (H) Antibody Titre:</label>
          <input
            type="text"
            className="form-control"
            name="typhiH"
            value={form.typhiH}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>S. Paratyphi (AH) Antibody Titre:</label>
          <input
            type="text"
            className="form-control"
            name="paraAH"
            value={form.paraAH}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>S. Paratyphi (BH) Antibody Titre:</label>
          <input
            type="text"
            className="form-control"
            name="paraBH"
            value={form.paraBH}
            onChange={handleChange}
          />
        </div>

        <h5 className="mt-4">HARMATOLOGY - MP</h5>
        <div className="mb-2">
          <label>MP Antigen (Card Test):</label>
          <input
            type="text"
            className="form-control"
            name="mpAntigen"
            value={form.mpAntigen}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>MP (Malarial Parasite):</label>
          <input
            type="text"
            className="form-control"
            name="mpParasite"
            value={form.mpParasite}
            onChange={handleChange}
          />
        </div>

        <h5 className="mt-4">SEROLOGY - CRP</h5>
        <div className="mb-2">
          <label>CRP (Qualitative/Quantitative):</label>
          <input
            type="text"
            className="form-control"
            name="crpQual"
            value={form.crpQual}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>CRP (Quantitative mg/L):</label>
          <input
            type="text"
            className="form-control"
            name="crpQuant"
            value={form.crpQuant}
            onChange={handleChange}
          />
        </div>

        <h5 className="mt-4">SEROLOGY - RA TEST</h5>
        <div className="mb-2">
          <label>RA Test:</label>
          <input
            type="text"
            className="form-control"
            name="raTest"
            value={form.raTest}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>RA (Quantitative) Test (Lu/ml):</label>
          <input
            type="text"
            className="form-control"
            name="raQuant"
            value={form.raQuant}
            onChange={handleChange}
          />
        </div>

        <h5 className="mt-4">BIOCHEMISTRY</h5>
        <div className="mb-2">
          <label>Random Blood Sugar (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="randomSugar"
            value={form.randomSugar}
            onChange={handleChange}
          />
        </div>

        <h5 className="mt-4">HEMOGRAM - ESR</h5>
        <div className="mb-2">
          <label>E.S.R. (mm/hr):</label>
          <input
            type="text"
            className="form-control"
            name="esr"
            value={form.esr}
            onChange={handleChange}
          />
        </div>

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          MP WIDAL + ESR REPORT
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">
          SEROLOGY - WIDAL EXAMINATION
        </h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>S. Typhi (O) Antibody Titre</td>
              <td>{form.typhiO}</td>
            </tr>
            <tr>
              <td>S. Typhi (H) Antibody Titre</td>
              <td>{form.typhiH}</td>
            </tr>
            <tr>
              <td>S. Paratyphi (AH)</td>
              <td>{form.paraAH}</td>
            </tr>
            <tr>
              <td>S. Paratyphi (BH)</td>
              <td>{form.paraBH}</td>
            </tr>
          </tbody>
        </table>

        <h5 className="text-decoration-underline">HARMATOLOGY - MP</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>MP Antigen (Card Test)</td>
              <td>{form.mpAntigen}</td>
            </tr>
            <tr>
              <td>MP (Malarial Parasite)</td>
              <td>{form.mpParasite}</td>
            </tr>
          </tbody>
        </table>

        <h5 className="text-decoration-underline">SEROLOGY - CRP</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>CRP (Qualitative/Quantitative)</td>
              <td>{form.crpQual}</td>
            </tr>
            <tr>
              <td>CRP (Quantitative)</td>
              <td>{form.crpQuant} mg/L (UP TO 0-8MG/L)</td>
            </tr>
          </tbody>
        </table>

        <h5 className="text-decoration-underline">SEROLOGY - RA TEST</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>RA Test</td>
              <td>{form.raTest}</td>
            </tr>
            <tr>
              <td>RA (Quantitative) Test</td>
              <td>{form.raQuant} Lu/ml (0-14 Lu/ml)</td>
            </tr>
          </tbody>
        </table>

        <h5 className="text-decoration-underline">BIOCHEMISTRY</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>Random Blood Sugar</td>
              <td>{form.randomSugar} mg/dl (80 to 140 mg/dl)</td>
            </tr>
          </tbody>
        </table>

        <h5 className="text-decoration-underline">HEMOGRAM - ESR</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>E.S.R.</td>
              <td>{form.esr} mm/hr (M: 0 to 09 / F: 0 to 20 mm/hr)</td>
            </tr>
          </tbody>
        </table>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default MpWidalEsrForm;
